import { useState } from "react";
import { useEffect } from "react";
import AddStoreProduct from "./AddStoreProduct";
import { Form, Table } from "react-bootstrap";
import UseToggle from "../../../../../Hooks/UseToggle";
import { CgArrowLongRight } from "react-icons/cg";
import ToolBar from "../../../../Componant/ToolBar";
import { storeProductServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeProductServices";
import UpdateStoreProduct from "./UpdateStoreProduct";

const StoreProductList = () => {
  const toggles = UseToggle();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [addNewProduct, setAddNewProduct] = useState(false);
  const [updateNewProduct, setUpdateNewProduct] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [storeProduct, setStoreProduct] = useState([]);
  const [storeProductCount, setStoreProductCount] = useState(0);
  const [storeProductIds, setStoreProductIds] = useState([]);

  // const toggleSingle = (id) => {
  //   setStoreProductIds((prev) =>
  //     prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
  //   );
  // };

  const toggleSingle = (product) => {
    setStoreProductIds((prev) => {
      if (prev.includes(product._id)) {
        return prev.filter((id) => id !== product._id);
      } else {
        setSelectedProduct(product); 
        return [product._id]; 
      }
    });
  };

  const toggleAll = () => {
    if (storeProductIds.length === storeProductCount) {
      setStoreProductIds([]);
    } else {
      setStoreProductIds(storeProduct.map((c) => c._id));
    }
  };

  const isAllChecked =
    storeProductCount > 0 && storeProductIds.length === storeProductCount;
  const isChecked = (id) => storeProductIds.includes(id);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(storeProductCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, storeProductCount);

  const getStoreProductList = async () => {
    setLoader(true);
    let data = await storeProductServices.getStoreProductList(
      "all",
      search,
      pageNumber,
      itemsPerPage,
    );
    setStoreProduct(data?.data || []);
    setStoreProductCount(data?.count || 0);
    setLoader(false);
  };

  useEffect(() => {
    getStoreProductList();
  }, [search, pageNumber, itemsPerPage]);

  return (
    <>
      {addNewProduct ? (
        <AddStoreProduct
          setAddNewProduct={setAddNewProduct}
          getStoreProductList={getStoreProductList}
        />
      ) : updateNewProduct ? (
        <UpdateStoreProduct
          setUpdateNewProduct={setUpdateNewProduct}
          getStoreProductList={getStoreProductList}
          productDetails={selectedProduct}
        />
      ) : (
        <>
          <ToolBar
            toggles={toggles}
            search={search}
            setSearch={setSearch}
            checkedIds={storeProductIds}
            setCheckedIds={setStoreProductIds}
            start={start}
            end={end}
            totalItems={storeProductCount}
            page={pageNumber}
            setPage={setPageNumber}
            setPageSize={setItemsPerPage}
            pageSize={itemsPerPage}
            totalPages={totalPages}
            setAddNewProduct={setAddNewProduct}
            setUpdateNewProduct={setUpdateNewProduct}
            addNewProduct
            deleteData
            updateNewProduct
            editField
          />
          <div className={`contacts-layout`}>
            <div
              className={`table-section overflow-auto bg-white `}
              style={{ height: "calc(100vh - 153px)" }}
            >
              <Table
                hover
                className="contacts-table mb-0"
                style={{ verticalAlign: "middle" }}
              >
                <thead>
                  <tr>
                    <th style={{ width: "30%" }}>
                      <div className="d-flex align-items-center gap-2">
                        <div className="px-2">
                          <Form.Check
                            type="checkbox"
                            checked={isAllChecked}
                            onChange={toggleAll}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                        <div>Title</div>
                      </div>
                    </th>
                    <th>Pricing</th>
                    <th>Stock</th>
                    <th>Category</th>
                    <th>Type</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {storeProduct?.map((item) => (
                    <tr key={item?._id}>
                      <td
                        className="text-truncate text-wrap"
                        style={{ maxWidth: 100 }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div className="px-2">
                            <Form.Check
                              type="checkbox"
                              checked={isChecked(item?._id)}
                              onChange={() => toggleSingle(item)}
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>
                          <div className="hstack gap-2">
                            <img
                              src="https://rukminim2.flixcart.com/image/612/612/xif0q/lipstick/a/1/7/-original-imahjru97xuzmryz.jpeg"
                              width={25}
                              height={25}
                              alt="Product thumbnail"
                            />
                            <div>
                              <div className="fw-medium">{item?.name}</div>
                              <small className="text-muted">{item?.slug}</small>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        ${item?.salePrice} -{" "}
                        <s className="text-muted">${item?.regularPrice}</s>
                      </td>
                      <td>16</td>
                      <td>
                        {item?.categoryName} <CgArrowLongRight />{" "}
                        {item?.subCategoryName}
                      </td>
                      <td>{item?.productType}</td>
                      <td>
                        <span
                          className={`text-capitalize badge ${item?.status === "publish" ? "bg-success" : item?.status === "inactive" ? "bg-danger" : "bg-warning text-dark"}`}
                        >
                          {item?.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default StoreProductList;
